module.exports = __webpack_public_path__ + "static/App_and_Web_Development-dcaa6344d4fba23aba2ea341c78198af.svg";